const lookupReducer = (state = {}, action) => {
    switch (action.type) {
        case "getLookupListSuccess":
            return Object.assign({}, state, {
                LookupList: action.data,
            });
            break;
        case "getLookupDetails":
            return Object.assign({}, state, {
                LookupDetails: action.data,
            });
            break;
        /*   case "LookupValue":
                  return Object.assign({}, state, {
                      LookupValue: action.data,
                  });
              break;  */
        case "LookupClear":
            return Object.assign({}, state, {
                LookupClear: action.data,
            });
            break;
        case "postFirePlanAttachmentUploadSuccess":
            return Object.assign({}, state, {
                FirePlanAttachment: action.data,
            });
            break;
        case "postShipContractAttachmentUploadSuccess":
            return Object.assign({}, state, {
                ShipContractAttachment: action.data,
            });
            break;
        case "postFlagAttachmentUploadSuccess":
            return Object.assign({}, state, {
                FlagAttachment: action.data,
            });
            break;
        case "postClassAttachmentUploadSuccess":
            return Object.assign({}, state, {
                ClassAttachment: action.data,
            });
            break;
        case "postMiscAttachmentUploadSuccess":
            return Object.assign({}, state, {
                MiscAttachment: action.data,
            });
            break;
        case "postModalAttachmentUploadSuccess":
            return Object.assign({}, state, {
                ModalAttachment: action.data,
            });
            break;
        case "getFlagSearchListSuccess":
            return Object.assign({}, state, {
                FlagSearchList: action.data,
            });
            break;
        case "getFlagApplicableServiceSuccess":
            return Object.assign({}, state, {
                GetFlagApplicableService: action.data,
            });
            break;
        case "getClassApplicableServiceSuccess":
            return Object.assign({}, state, {
                GetClassApplicableService: action.data,
            });
            break;
        case "getMiscApplicableServiceSuccess":
            return Object.assign({}, state, {
                GetMiscApplicableService: action.data,
            });
            break;
        case "flagDetails":
            return Object.assign({}, state, {
                flagDetail: action.data,
            });
            break;
        case "getMakeSearchListSuccess":
            return Object.assign({}, state, {
                MakeSearchList: action.data,
            });
            break;
        case "getServiceTypeUsedSuccess":
            return Object.assign({}, state, {
                ServiceTypeUsed: action.data,
            });
            break;
        case "GetIntervalUsed":
            return Object.assign({}, state, {
                IntervalUsed: action.data,
            });
            break;
        case "classSearch":
            return Object.assign({}, state, {
                classSearch: action.data,
            });
            break;
        case "flagSearch":
            return Object.assign({}, state, {
                flagSearch: action.data,
            });
            break;
        case "miscSearch":
            return Object.assign({}, state, {
                miscSearch: action.data,
            });
            break;
        case "makeModelSearch":
            return Object.assign({}, state, {
                makeModelSearch: action.data,
            });
            break;
        default: {
            return state;
        }
    }
};
export default lookupReducer;
